





































































import { Vue, Component, Prop } from "vue-property-decorator";
import api from "@/getinfo-api";
import { TestsList as ITestsList } from "@/api/models/tests-list";
import tests, { TestListParams } from "@/getinfo-api/tests";
import { CourseLectureEdit as ICourseLectureEdit } from "@/api/models/course-lecture-edit";
import { CourseEdit as ICourseEdit } from "@/api/models/course-edit";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { Practice as IPractice } from "@/api/models/practice";
import { PracticeEdit as IPracticeEdit } from "@/api/models/practice-edit";
import { debounce } from "lodash";

@Component
export default class AssignTestToEntity extends Vue {
  @Prop() courseId!: string;
  @Prop() companyId!: string;
  @Prop() courseLectureId?: string;
  @Prop() existTestId?: string;
  @Prop() existPractice?: IPractice;
  testsList!: ITestsList;
  selectedTestId!: string;
  checkPractice!: string | undefined;
  showSpinner: boolean = false;
  data() {
    return {
      practicePassList: undefined,
      testsList: undefined,
      selectedTestId: undefined,
      checkPractice: undefined
    };
  }

  getLabel(option: any) {
    let label;
    if (typeof option === "object") {
      label = `${option.title || ""}`;
    }
    return label;
  }

  get searchTest() {
    return debounce(this.getTestByTitle, 500);
  }

  getTestByTitle(searchString: string | undefined = undefined) {
    if (this.companyId) {
      this.showSpinner = true;
      let params: TestListParams = {
        companyId: this.companyId,
        title: searchString,
        limit: 30
      };
      tests(params)
        .then((res: { data: ITestsList }) => {
          this.testsList = res.data;
          this.showSpinner = false;
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  mounted() {
    if (this.companyId) {
      let params: TestListParams = {
        companyId: this.companyId,
        limit: 1000,
        offset: 0
      };
      tests(params)
        .then((res: { data: ITestsList }) => {
          this.testsList = res.data;
          this.testsList.tests.sort(
            (a, b) =>
              new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
          );
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
    if (this.existTestId) {
      this.selectedTestId = this.existTestId;
    }
    if (this.existPractice && this.existPractice.enabled) {
      this.checkPractice = this.existPractice.id;
    }
  }

  updatePracticeStatus() {
    if (this.existPractice) {
      if (this.checkPractice === undefined) {
        let params: IPracticeEdit = {
          enabled: false
        };
        api.PracticeApi.edit(this.$route.params.courseId, params)
          .then(() => {
            this.$emit("update");
            this.$bvToast.toast(
              this.$tc(this.$translate.ChangesHaveBeenSuccessfullySaved),
              {
                variant: "success",
                title: this.$tc(this.$translate.Successful)
              }
            );
          })
          .catch(
            (err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
              this.$store.dispatch("errorException", {
                vm: this,
                error: err.response
              });
            }
          );
      } else {
        let params: IPracticeEdit = {
          enabled: true
        };
        api.PracticeApi.edit(this.$route.params.courseId, params)
          .then(() => {
            this.$emit("update");
            this.$bvToast.toast(
              this.$tc(this.$translate.ChangesHaveBeenSuccessfullySaved),
              {
                variant: "success",
                title: this.$tc(this.$translate.Successful)
              }
            );
          })
          .catch(
            (err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
              this.$store.dispatch("errorException", {
                vm: this,
                error: err.response
              });
            }
          );
      }
    }
  }

  assignTest() {
    this.updatePracticeStatus();
    if (this.courseLectureId) {
      if (this.selectedTestId) {
        let params: ICourseLectureEdit = {
          id: this.courseLectureId,
          testId: this.selectedTestId
        };
        api.CourseLectureApi.edit(this.courseId, [params])
          .then(() => {
            this.$bvToast.toast(
              this.$tc(this.$translate.ChangesHaveBeenSuccessfullySaved),
              {
                variant: "success",
                title: this.$tc(this.$translate.Successful)
              }
            );
            this.$emit("update");
          })
          .catch(
            (err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
              this.$store.dispatch("errorException", {
                vm: this,
                error: err.response
              });
            }
          );
      } else {
        let params: ICourseLectureEdit = {
          id: this.courseLectureId,
          testNull: true
        };
        api.CourseLectureApi.edit(this.courseId, [params])
          .then(() => {
            this.$bvToast.toast(
              this.$tc(this.$translate.ChangesHaveBeenSuccessfullySaved),
              {
                variant: "success",
                title: this.$tc(this.$translate.Successful)
              }
            );
            this.$emit("update");
          })
          .catch(
            (err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
              this.$store.dispatch("errorException", {
                vm: this,
                error: err.response
              });
            }
          );
      }
    } else {
      if (this.selectedTestId) {
        let params: ICourseEdit = {
          testId: this.selectedTestId
        };
        api.CourseApi.edit(this.courseId, params)
          .then(() => {
            this.$bvToast.toast(
              this.$tc(this.$translate.ChangesHaveBeenSuccessfullySaved),
              {
                variant: "success",
                title: this.$tc(this.$translate.Successful)
              }
            );
            this.$emit("update");
          })
          .catch(
            (error: AxiosError<IErrorResponse | IValidationErrorResponse>) => {
              if (error.response) {
                this.$bvToast.toast(`${error.response.data.message}`, {
                  variant: "danger",
                  title: this.$tc(this.$translate.Error)
                });
              }
            }
          );
      } else {
        let params: ICourseEdit = {
          testIdNull: true
        };
        api.CourseApi.edit(this.courseId, params)
          .then(() => {
            this.$bvToast.toast(
              this.$tc(this.$translate.ChangesHaveBeenSuccessfullySaved),
              {
                variant: "success",
                title: this.$tc(this.$translate.Successful)
              }
            );
            this.$emit("update");
          })
          .catch(
            (error: AxiosError<IErrorResponse | IValidationErrorResponse>) => {
              if (error.response) {
                this.$bvToast.toast(`${error.response.data.message}`, {
                  variant: "danger",
                  title: this.$tc(this.$translate.Error)
                });
              }
            }
          );
      }
    }
  }
}
